import "./App.css";
import "./common.css";
import "./responsive.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/home";
import Introduce from "./pages/introduce";
import WrapperLayout from "./layouts";
import Careers from "./pages/careers";
import Contact from "./pages/contact";
import News from "./pages/news";
import CareersDetail from "./pages/careers-detail";
import NewsDetail from "./pages/news-detail";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Services from "./pages/services";
import Knowledge from "./pages/knowlegde";
function App() {
  const defaultLanguage = localStorage.getItem('language') || 'vi';
      const {  i18n } = useTranslation();
      useEffect(() => {
          i18n.changeLanguage(defaultLanguage);
      }, []);
  return (
    <Router>
      <div className="app font-bauhaus">
        <WrapperLayout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/gioi-thieu" element={<Introduce />} />
            <Route path="/dich-vu" element={<Services />} />
            <Route path="/kien-thuc" element={<Knowledge />} />
            <Route path="/tin-tuc" element={<News />} />
            {/* <Route path="/chi-tiet-tin" element={<NewsDetail />} /> */}
            {/* <Route path="/tuyen-dung" element={<Careers />} /> */}
            {/* <Route path="/tuyen-dung/:id" element={<CareersDetail />} /> */}
            <Route path="/lien-he" element={<Contact />} />
          </Routes>
        </WrapperLayout>
      </div>
    </Router>
  );
}

export default App;
